const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/soh/eCheckin/sections/components/metakat/ZuweisenderArzt/ZuweisenderArztField.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mMetaKatDropDown } from '@cistec/common_web/modules/CIS4m/components/CIS4mMetaKatDropDown';
import { useCIS4FormMetaKatData } from 'App/store/cis4m';
import { TextInput } from '@cistec/common_web/utils/intlUtils';
import { useIntl } from 'react-intl';

interface Props {
    label: TextInput;
    path: string;
    hidden?: boolean;
    required?: boolean;
}

export const ZuweisenderArztField = forwardRef((props: Props, ref: any) => {
    const { locale } = useIntl();
    const dropdownRef = useCIS4m(ref);

    const hidden = props.hidden ?? false;
    const required = props.required ?? false;

    return (
        <CIS4mMetaKatDropDown
            ref={dropdownRef}
            label={props.label}
            path={props.path}
            pcode={'e9b1e13e-5cbd-4e7c-b2c0-246402042e3b'}
            valuePath="FKEY"
            labelPath={`CONTENT.Lang.${locale}`}
            hidden={hidden}
            required={required}
            dataHook={useCIS4FormMetaKatData}
        />
    );
});

ZuweisenderArztField.displayName = 'ZuweisenderArztField';
